import { useContext, useState } from "react";
import * as tus from "tus-js-client";
import { Context } from "../../context";
import { Post } from "../../fetch";
import { Progress, Space, message, Tag, Select, Typography, Col } from "antd";
import { languageCodeList } from "../../langmap";


const UploadAudio = (props) => {
    const { Text, Link, Title } = Typography;
    const { token, apiUrl, transcodeUrl, superAdmin } = useContext(Context);
    const [audioUploading, setaudioUploading] = useState(false);
    const [audioUploadProgress, setaudioUploadProgress] = useState(0);

    const handleChange = (e, type) => {
        const file = e.target.files[0];
        let setUploadProgressFn;
        setaudioUploading(true);
        setUploadProgressFn = setaudioUploadProgress;

        const upload = new tus.Upload(file, {
            endpoint: `${transcodeUrl}/files`,
            retryDelays: [0, 3000, 5000, 10000, 20000],
            metadata: {
                filename: file.name,
                filetype: file.type,
            },
            onError: (error) => {
                console.log("Failed because: " + error);
            },
            onProgress: (bytesUploaded, bytesTotal) => {
                var percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
                setUploadProgressFn(percentage);
                console.log(bytesUploaded, bytesTotal, percentage + "%");
            },
            onSuccess: () => {
                Post(
                    `${transcodeUrl}/submitJob`,
                    token,
                    {
                        id: props.upload._id,
                        loc: upload.url.split("/").slice(-1)[0],
                        media_type: `${props.upload.type}`,
                    },
                    (result) => {
                        console.log(result);
                    },
                    () => {
                        console.error(`Error transcoding content`);
                    }
                );
                setUploadProgressFn(0);
                message.success("Your audio is succesfully uploaded");
                console.log("Download %s from %s", upload.file.name, upload.url);
            },
        });

        upload.start();
    };

    return (
        <>
            {/* <Card title={"audio  (Mp4 only)"} style={{ width: 600 }}> */}
            <>
                {"audio" in props.activeObj ? (
                    <>
                        {"audio" in props.activeObj ? (
                            <Tag color="green" style={{ fontSize: 16 }}>
                                Audio Exists
                            </Tag>
                        ) : null}
                        <br />
                        <br />
                    </>
                ) : null}
                <Col span={100}>
                    <Space direction="horizontal">
                        <Text>Audio</Text>
                        <Col span={10}></Col>
                        {/* {"audio" in props.activeObj ? (
                            <Tag color="green" style={{ fontSize: 16 }}>
                                Audio Exists
                            </Tag>
                        ) : null} */}
                        <Select style={{ width: '200px' }} allowClear>
                            {languageCodeList.map((v) => (
                                <Select.Option key={v["code"]} value={v["code"]}>
                                    {v["native"]} - {v["name"]}
                                </Select.Option>
                            ))}
                        </Select>
                        <input
                            type="file"
                            onChange={(e) => handleChange(e, "audio")}
                            accept="audio/mp3"
                        />
                    </Space>
                </Col>
                {audioUploadProgress ? (
                    <Progress percent={audioUploadProgress} />
                ) : null}
            </>
            {/* </Card> */}
        </>
    );
};

export default UploadAudio;
